(function ($) {

    $(document).on('click', '#submit-editor-addresses', function (e) {
        e.preventDefault();

        let form = $('#js-edit-addresses'),
            account_addresses = {}

        $('#js-edit-addresses input').each(function () {
            account_addresses[$(this).attr("name")] = $(this).val();
        })

        let data = {
            action: 'edit_user_addresses',
            account_addresses: account_addresses,
        };

        $.ajax({
            type: 'post',
            url: wc_add_to_cart_params.ajax_url,
            data,
            beforeSend: function () {
                // add loader
                form.append('<div class="form__loader"><i class="icon-load"></i></div>');
            },
            success: function (response) {
                // remove loader
                $(form).find('.form__loader').remove();

                if (response.success) {
                    form.after('<div class="js-edit-message" style="color:green;">' + response.message + '</div>');
                } else {
                    form.after('<div class="js-edit-message" style="color:red;">' + response.message + '</div>');
                }

                setTimeout(function () {
                    $('.js-edit-message').remove()
                }, 3000)

            },
        });
    })
})(jQuery);